import { useQuery } from '@hooks/reactQuery';

import { getFilesMilestonesToLink } from '@api/portalFiles';

import { extractQueryParams } from '@utils/common';
import { portalMilestonesToLinkFormatted } from '@utils/formatter';

import { IPortalMilestonesForAttachOption } from '@interfaces/portal/folders';

import { EUserRoles } from '@enums/common';

import { GET_PORTAL_FILES_MILESTONES_TO_LINK } from '@constants/queryKeys';

interface IUseQueryFilesMilestonesToLinkReturned {
	portalFilesMilestonesToLink: IPortalMilestonesForAttachOption[];
	isLoadingPortalFilesMilestonesToLink: boolean;
}

interface IUseQueryFilesMilestonesToLink {
	fileId: string | null;
	projectId?: string;
}

export const useQueryFilesMilestonesToLink = ({
	fileId,
	projectId,
}: IUseQueryFilesMilestonesToLink): IUseQueryFilesMilestonesToLinkReturned => {
	const {
		data,
		isInitialLoading,
		isFetching,
	} = useQuery({
		queryKey: [GET_PORTAL_FILES_MILESTONES_TO_LINK, { fileId, projectId }],
		queryFn: extractQueryParams(getFilesMilestonesToLink),
		enabled: [!!fileId, !!projectId],
		allowedRoles: [EUserRoles.portalProjectAdministrator, EUserRoles.portalProjectMember],
		select: requestTypes => portalMilestonesToLinkFormatted(requestTypes),
		refetchOnReconnect: false,
		refetchOnWindowFocus: false,
		refetchOnMount: true,
		staleTime: 0,
	});

	return {
		portalFilesMilestonesToLink: data || [],
		isLoadingPortalFilesMilestonesToLink: isFetching || isInitialLoading,
	};
};
